import { useRouter } from 'next/router'
import { useContext, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { AppConfig } from '../app-config'
import AppContext from '../store/AppContext'
import { SET_IXIGO_SITE } from '../store/Constants'
import getUserDetails from '../utils/actions/getUserDetails'
// import { GA_TRACKING_ID, GLOBAL_GA_TRACKING_ID } from '../utils/analytics/gtag'
import {
	getExpiryRecord,
	identifyLeadSource,
	setLeadSourceParams,
} from '../utils/analytics/leadSourceHelper'
import isIxigoPartnersSite from '../utils/isIxigoPartnersSite'
import isEmpty from '../utils/lodashUtils/isEmpty'
import { EVENT_PAGE_VISITED, trackEvent } from '../utils/ML/EventsTracker'

const AnalyticsWrapper = ({ children, pageViewedProps, locale }) => {
	const router = useRouter()
	const [{ userDetails }, dispatch] = useContext(AppContext)
	const reduxDispatch = useDispatch()
	useEffect(() => {
		if (!userDetails) {
			getUserDetails({ dispatch, reduxDispatch })
		}
	}, [dispatch, reduxDispatch, userDetails])

	// Check ixigo partners site
	useEffect(() => {
		console.log({ REACT_APP_DOMAIN_URL: AppConfig.domain_url })

		dispatch({
			type: SET_IXIGO_SITE,
			payload: {
				isIxigoPartnersSite: isIxigoPartnersSite(),
			},
		})
	}, [])

	// const initialize = id => {
	// 	// Load Google Analytics
	// 	if (!window.ga) {
	// 		;(function (i, s, o, g, r, a, m) {
	// 			i['GoogleAnalyticsObject'] = r
	// 			i[r] =
	// 				i[r] ||
	// 				function () {
	// 					;(i[r].q = i[r].q || []).push(arguments)
	// 				}
	// 			i[r].l = 1 * new Date()
	// 			a = s.createElement(o)
	// 			m = s.getElementsByTagName(o)[0]
	// 			a.defer = 1
	// 			a.src = g
	// 			m && m.parentNode.insertBefore(a, m)
	// 		})(
	// 			window,
	// 			document,
	// 			'script',
	// 			'https://www.google-analytics.com/analytics.js',
	// 			'ga',
	// 		)
	// 	}

	// 	// Initialize Google Analytics
	// 	window.ga('create', id, 'auto')

	// 	/**
	// 	 * Added this code for google analytics - code optimization
	// 	 * @author - @akbarbasha
	// 	 */
	// 	window.ga('require', 'GTM-TSJ9VC7')
	// 	window.ga('send', 'pageview')
	// }

	// const sendPageView = pathname => {
	// 	console.log('URL: ', pathname)

	// 	// Do nothing if GA was not initialized due to a missing tracking ID.
	// 	if (!window.ga) {
	// 		return
	// 	}

	// 	// Sets the page value on the tracker.
	// 	window.ga('set', 'page', pathname)

	// 	// Sending the pageview no longer requires passing the page
	// 	// value since it's now stored on the tracker object.
	// 	window.ga('send', 'pageview')
	// }

	useEffect(() => {
		const ipInfo = JSON.parse(localStorage.getItem('user-ip-info')) || {}
		if (isEmpty(ipInfo)) {
			const url =
				'https://api.ipstack.com/check?access_key=91285d7c267448fab33599e6dd0d8c99'
			fetch(url)
				.then(response => {
					return response.json()
				})
				.then(ipInfo => {
					localStorage.setItem('user-ip-info', JSON.stringify(ipInfo))
				})
				.catch(() => {})
		}

		sessionStorage.setItem('locale', locale)

		if (sessionStorage && !sessionStorage.getItem('source')) {
			sessionStorage.setItem('source', window.location.href)
		}

		// if (process.env.NODE_ENV === 'production') {
		// 	document.onreadystatechange = () => {
		// 		if (document.readyState == 'complete') {
		// 			setTimeout(() => {
		// 				initialize(locale ? GLOBAL_GA_TRACKING_ID : GA_TRACKING_ID)
		// 				sendPageView(router.asPath)
		// 			}, 0)
		// 		}
		// 	}
		// }
	}, [locale])

	useEffect(() => {
		/**
		 * LocalStorage Event will be triggered in all tabs and
		 * will carry the context across tabs for the same domain
		 * REQUESTING_SHARED_CREDENTIALS - this will be triggered while opening new tab
		 * (event.key === 'REQUESTING_SHARED_CREDENTIALS' && credentials)
		 * on storage event callback old tab which has the data in sessionStorage.leadSource
		 * window.localStorage.setItem('CREDENTIALS_SHARING', JSON.stringify(credentials))
		 * this will trigger another storage event - and carry the info in event.newValue
		 * (event.key === 'CREDENTIALS_SHARING' && !credentials)
		 * this will be true in the new tab - and the event.newValue has the copy
		 * which will be stored in the session
		 * window.sessionStorage.setItem('leadSource', event.newValue);
		 * */
		window.addEventListener('storage', event => {
			const credentials = JSON.parse(
				window.sessionStorage.getItem('leadSource'),
			)
			if (event.key === 'REQUESTING_SHARED_CREDENTIALS' && credentials) {
				window.localStorage.setItem(
					'CREDENTIALS_SHARING',
					JSON.stringify(credentials),
				)
				window.localStorage.removeItem('CREDENTIALS_SHARING')
			}

			if (event.key === 'CREDENTIALS_SHARING' && !credentials) {
				window.sessionStorage.setItem('leadSource', event.newValue)
			}
		})

		if (router.query.utm_source) {
			setLeadSourceParams(router.query, true)
		} else {
			identifyLeadSource()

			window.localStorage.setItem(
				'REQUESTING_SHARED_CREDENTIALS',
				Date.now().toString(),
			)
			window.localStorage.removeItem('REQUESTING_SHARED_CREDENTIALS')
		}

		// // Google Click id tracking
		// const gclidParam = router.query.gclid
		// const gclsrcParam = router.query.gclsrc
		// const isGclsrcValid = !gclidParam || gclsrcParam?.indexOf('aw') !== -1

		// if (gclidParam && isGclsrcValid) {
		// 	const gclidRecord = getExpiryRecord(gclidParam)

		// 	localStorage.setItem('gclid', JSON.stringify(gclidRecord))
		// }
	}, [router.query])

	useEffect(() => {
		// Google Click id tracking
		const gclidParam = router.query?.gclid
		const gclsrcParam = router.query?.gclsrc
		const isGclsrcValid = !gclidParam || gclsrcParam?.indexOf('aw') !== -1

		if (gclidParam && isGclsrcValid) {
			const gclidRecord = getExpiryRecord(gclidParam)

			localStorage.setItem('gclid', JSON.stringify(gclidRecord))
		}
	}, [router.query.gclid, router.query.gclsrc])

	useEffect(() => {
		const handleRouteChange = url => {
			console.log('URL: ', url)

			const ipInfo = JSON.parse(localStorage.getItem('user-ip-info')) || {}
			const leadSourceData = JSON.parse(sessionStorage.getItem('leadSource'))

			let eventProps = {
				is_logged_in: loggedIn,
				leadSource: {
					...leadSourceData,
					ipInfo,
				},
				ipAddress: sessionStorage.getItem('ipaddress'),
			}

			const { loggedIn, email, mobileNumber, countryPhoneCode, name } =
				userDetails || {}
			if (loggedIn) {
				eventProps = {
					...eventProps,
					email,
					mobile_number: mobileNumber,
					country_phone_code: countryPhoneCode,
					name,
				}
			}

			// Send the page value to Segments
			trackEvent(EVENT_PAGE_VISITED, {
				page: router.asPath,
				...eventProps,
				...pageViewedProps,
			})
		}
		router.events.on('routeChangeComplete', handleRouteChange)

		return () => {
			router.events.off('routeChangeComplete', handleRouteChange)
		}
	}, [pageViewedProps, router, userDetails])

	return children
}

export default AnalyticsWrapper
